export function isMobile(): boolean {
  if (import.meta.client) {
    return screen.width < 770;
  }
  return false;
}
